import { EventFactory } from './EventFactory';
import { AvailableConfirmationEvents } from './types/helperTypes/availableConfirmationEvents';
import { SERPConfirmationEventType, SERPEvent } from './types/SERPEvents';

/**
 * Use this to select the first available confirmation event from the list of available confirmation events
 */
export const pickConfirmationEventType = (
    confirmationEvents: Array<SERPConfirmationEventType>,
    availableConfirmationEvents: AvailableConfirmationEvents
): SERPConfirmationEventType | undefined => {
    return confirmationEvents.find((confirmationEvent) => {
        return Object.values(availableConfirmationEvents).includes(confirmationEvent);
    });
};

export class EventConfirmer {
    private readonly eventFactory: EventFactory;

    constructor() {
        this.confirmEventDelivery = this.confirmEventDelivery.bind(this);
        this.eventFactory = new EventFactory();
    }

    public confirmEventDelivery(
        expectedConfirmations: Array<SERPConfirmationEventType>,
        availableConfirmations: AvailableConfirmationEvents,
        originalEvent?: SERPEvent
    ): void {
        const confirmationEvent = pickConfirmationEventType(expectedConfirmations, availableConfirmations);
        if (!confirmationEvent) {
            console.error('SERP Event delivery confirmation failed. No confirmation event available');
            return;
        }

        this.emitConfirmation(confirmationEvent);
    }

    private emitConfirmation(confirmationEvent: SERPConfirmationEventType): void {
        window.dispatchEvent(this.eventFactory.createConfirmationEvent(confirmationEvent));
    }
}
